import IncidentSummary from '../incident-summary';
import {
  IncidentThumbsDownInline,
  IncidentThumbsUpInline,
} from '../incident-inline-icons';

<IncidentSummary
  summary="Uma instabilidade da plataforma entre 11 e 13 de agosto de 2026 causou coleta incompleta de eventos de analytics em algumas campanhas."
  status="resolved"
  startedAt="2026-08-11T19:00:00-03:00"
  resolvedAt="2026-08-13T09:00:00-03:00"
/>

## O que aconteceu

No dia 11 de agosto de 2026, o servidor responsável por coletar dados de eventos (impressões, cliques, entre outros) do seu app ficou temporariamente indisponível. Por causa disso, ele parou temporariamente de registrar alguns dos eventos recebidos.

## Como isso afeta você

<p><IncidentThumbsDownInline />Se você enviou alguma campanha entre os dias 11 e 13 de Agosto, os números de impressões e cliques exibidos para essas campanhas podem estar parcial ou totalmente incompletos. </p>

<p><IncidentThumbsUpInline />As campanhas em si foram entregues normalmente aos seus usuários, o problema afetou apenas nossa capacidade de **rastrear e reportar** esses dados, não a capacidade de enviar as campanhas.</p>

<p><IncidentThumbsUpInline />**Os usuários finais do seu app não foram afetados em nenhum momento** e não perceberam nada de diferente, o incidente foi restrito ao nosso sistema interno de coleta de dados e não teve nenhum impacto visível na experiência deles.</p>

<p><IncidentThumbsUpInline />**Não houve nenhuma interrupção nos pedidos feitos dentro do aplicativo**, e a experiência de compra dos seus clientes não mudou em nenhum momento. Esse incidente não afetou os sistemas da sua loja, incluindo pedidos, pagamentos ou qualquer outra funcionalidade relacionada, o impacto ficou restrito exclusivamente aos dados de rastreamento de campanhas.</p>

## O que fizemos

Identificamos a causa raiz, restabelecemos a disponibilidade do servidor afetado e restauramos a coleta normal de eventos.

## O que você deve fazer

- Nenhuma ação é necessária da sua parte.
- Para campanhas enviadas nesse período, considere os números de impressões/cliques/etc como incompletos, e não como zero.
- Se você usa esses dados em relatórios, recomendamos sinalizar as campanhas desse período como tendo dados parciais.

## O que estamos fazendo para evitar que isso se repita

Estamos implementando monitoramento automatizado e alertas nesse servidor, para identificar e resolver problemas de disponibilidade antes que afetem a coleta de dados.
